function initMap() {
		var sfl_container = jQuery("#contact-map");
		var sfl_lat = parseFloat( sfl_container.attr('data-lat'));
		var sfl_lng = parseFloat(sfl_container.attr('data-lng'));
		var pin = sfl_container.attr('data-pin');
		var sfl_center = {lat: sfl_lat, lng: sfl_lng};

		var map = new google.maps.Map(document.getElementById('contact-map'), {
		zoom: 15,
		center: sfl_center,
		});

		new google.maps.Marker({
						position: sfl_center,
						map: map,
						animation: google.maps.Animation.DROP,
						icon: pin,
					});
}

$(document).ready(function(){
	google.maps.event.addDomListener(window, 'load', initMap);
});



// WEBPACK FOOTER //
// ./scripts/map/map-single.js